export default {
  title: 'Integrations',
  pageTitle: 'Integrations | Thanx',
  card: {
    via: 'via',
    enabled: 'Enabled',
    coming_soon: 'Coming soon',
    learn_more: 'Learn more',
    contact_us: 'Contact us to enable this integration',
  },
  help: 'Help',
  how_to_enable_integrations: 'How to enable integrations',
  requiresPaidAddon: 'Requires paid add-on.',
  managed_via_thanx: 'Managed via Thanx',
  managed_by_olo: 'Managed by Olo',
  posInstoreSkuData: {
    title: 'POS — In-store SKU data',
    emailSubject: 'I would like to enable %{pos} for in-store SKU data',
    toast: {
      title: 'Toast',
    },
    revel: {
      title: 'Revel',
    },
    oloOmnivore: {
      title: 'Olo Omnivore',
      description: 'Multiple POS integrations. Requires paid add-on.',
    },
    qu: {
      title: 'Qu',
    },
    ncr: {
      title: 'NCR',
    },
    square: {
      title: 'Square',
    },
    parBrink: {
      title: 'PAR Brink',
    },
  },
  posInstoreOfferManagement: {
    title: 'POS — In-store offer management',
    emailSubject: 'I would like to enable %{pos} for in-store offer management',
    thanx: {
      title: 'Thanx',
      description:
        'Manual offer management. This is always available to you but configuration options may change if another partner integration is enabled.',
    },
    toast: {
      title: 'Toast',
    },
    fishbowl: {
      title: 'Fishbowl',
      description: 'Multiple POS integrations. Requires paid add-on.',
    },
    ncr: {
      title: 'NCR',
    },
    qu: {
      title: 'Qu',
    },
    square: {
      title: 'Square',
    },
    shift4: {
      title: 'Shift4',
    },
    parBrink: {
      title: 'PAR Brink',
    },
    franpos: {
      title: 'FranPOS',
    },
    tabit: {
      title: 'Tabit',
    },
    geniusXenial: {
      title: 'Genius for Enterprise (Xenial)',
    },
  },
  posInstoreRedemption: {
    title: 'POS — In-store redemption',
    emailSubject: 'I would like to enable %{pos} for in-store redemption',
    toast: {
      title: 'Toast',
    },
  },
  digitalOrderManagement: {
    title: 'Digital order management',
    description: 'Only 1 partner integration may be on.',
    olo: {
      title: 'Olo',
    },
    toast: {
      title: 'Toast',
    },
    openTender: {
      title: 'Open Tender',
    },
    deliverect: {
      title: 'Deliverect',
    },
    cardfree: {
      title: 'CardFree',
    },
    square: {
      title: 'Square',
    },
    onosys: {
      title: 'Onosys',
    },
  },
  delivery: {
    title: 'Delivery',
    oloDispatch: {
      title: 'Olo Dispatch',
    },
    doordash: {
      title: 'Doordash',
    },
    uber: {
      title: 'Uber',
    },
    vromo: {
      title: 'Vromo',
    },
    cartwheel: {
      title: 'Cartwheel',
    },
    deliverect: {
      title: 'Deliverect',
    },
  },
  cdp: {
    title: 'CDP',
    emailSubject: 'I would like to enable %{cdp} as my CDP',
    oloGdp: {
      title: 'Olo GDP',
    },
    bikky: {
      title: 'Bikky',
    },
    delightable: {
      title: 'Fishbowl Delightable',
    },
    klaviyo: {
      title: 'Klaviyo',
    },
    customerxi: {
      title: 'CustomerXi',
    },
  },
  emailMarketing: {
    title: 'Marketing automation - Email',
    description:
      'You may turn on up to 1 partner integration and still continue to use Thanx.',
    emailSubject:
      'I would like to enable %{integration} for email marketing automation',
    thanx: {
      title: 'Thanx',
      description:
        'Default marketing automation. This is always available to you.',
    },
    klaviyo: {
      title: 'Klaviyo',
    },
    braze: {
      title: 'Braze',
    },
    oloGdp: {
      title: 'Olo GDP',
    },
    fishbowl: {
      title: 'Fishbowl',
    },
    attentive: {
      title: 'Attentive',
    },
    oloEngage: {
      title: 'Olo Engage',
    },
  },
  smsMarketing: {
    title: 'Marketing automation - SMS',
    description:
      'You may turn on up to 1 partner integration and still continue to use Thanx.',
    emailSubject:
      'I would like to enable %{integration} for SMS marketing automation',
    thanx: {
      title: 'Thanx',
      description:
        'Default marketing automation. This is always available to you.',
    },
    klaviyo: {
      title: 'Klaviyo',
    },
    attentive: {
      title: 'Attentive',
    },
  },
  marketingAutomationWifi: {
    title: 'Marketing automation - WiFi',
    description: null,
    emailSubject:
      'I would like to enable %{integration} for email marketing automation',
    adentro: {
      title: 'Adentro',
      description:
        'Default marketing automation. This is always available to you.',
    },
    gozone: {
      title: 'Smart Wi-Fi',
    },
  },
  feedback: {
    title: 'Feedback and reputation management',
    description:
      'You may turn on up to 1 partner integration. Turning on a partner integration will turn off Thanx feedback.',
    emailSubject: 'I would like to enable %{integration} for customer feedback',
    thanx: {
      title: 'Thanx',
      description:
        'Default feedback tool. This feature gets turned off when another feedback integration is enabled.',
    },
    tattle: {
      title: 'Tattle',
    },
    ovation: {
      title: 'Ovation',
    },
    yumpingo: {
      title: 'Yumpingo',
    },
    guestxm: {
      title: 'GuestXM',
    },
    momos: {
      title: 'Momos',
    },
    blackBoxIntelligence: {
      title: 'Black Box Intelligence',
    },
  },
  customDataCapture: {
    title: 'Custom data capture',
    emailSubject:
      'I would like to enable %{integration} for custom data capture',
    jotform: {
      title: 'Jotform',
    },
  },
  locationIntelligence: {
    title: 'Location intelligence',
    emailSubject:
      'I would like to enable %{integration} for location intelligence',
    flybuy: {
      title: 'Flybuy',
    },
  },
  storedValue: {
    title: 'Stored value',
    ansa: {
      title: 'Ansa',
    },
  },
  giftCard: {
    title: 'Gift cards',
    valutec: {
      title: 'Valutec',
    },
  },
  gamification: {
    title: 'Gamification',
    emailSubject: 'I would like to enable %{integration} for gamification',
    brame: {
      title: 'Brame',
    },
    peekPoke: {
      title: 'Peek & Poke',
    },
  },
  businessIntelligence: {
    title: 'Business Intelligence',
    emailSubject:
      'I would like to enable %{integration} for Business Intelligence',
    bikky: {
      title: 'Bikky',
    },
    rad: {
      title: 'RAD',
    },
    ingestAi: {
      title: 'Ingest AI',
    },
  },
  inStoreAudio: {
    title: 'In Store Audio',
    emailSubject: 'I would like to enable %{integration} for In Store Audio',
    customChannels: {
      title: 'Custom Channels',
    },
  },
  databaseDestinations: {
    title: 'Database Destinations',
    emailSubject:
      'I would like to enable %{integration} for Database Destinations',
    mysql: {
      title: 'MySQL',
    },
    postgresql: {
      title: 'PostgreSQL',
    },
    mariadb: {
      title: 'MariaDB',
    },
    mongodb: {
      title: 'MongoDB',
    },
    oracle: {
      title: 'Oracle',
    },
    sqlServer: {
      title: 'SQL Server',
    },
    auroraMysql: {
      title: 'Aurora MySQL',
    },
    auroraPostgresql: {
      title: 'Aurora PostgreSQL',
    },
    singlestore: {
      title: 'SingleStore',
    },
  },
  thanxConnex: {
    title: 'Thanx Connex',
    emailSubject: 'I would like to enable %{integration} for Thanx Connex',
    bigQuery: {
      title: 'BigQuery',
    },
    clickhouse: {
      title: 'ClickHouse',
    },
    databricks: {
      title: 'Databricks',
    },
    athena: {
      title: 'Athena',
    },
    firebolt: {
      title: 'Firebolt',
    },
    materialize: {
      title: 'Materialize',
    },
    redshift: {
      title: 'Redshift',
    },
    snowflake: {
      title: 'Snowflake',
    },
  },
  kiosksPayAtTable: {
    title: 'Kiosks & Pay at Table',
    emailSubject:
      'I would like to enable %{integration} for Kiosks & Pay at Table',
    bite: {
      title: 'Bite',
    },
    grubbrr: {
      title: 'Grubbrr',
    },
    toast: {
      title: 'Toast',
    },
    upnGo: {
      title: "up'n Go",
    },
    sunday: {
      title: 'Sunday',
    },
  },
}
